module.exports = __webpack_public_path__ + "img/sv103.a3dfc90f.svg";